<div
    class="container-fluid well"
    data-test-automation="crown-state-land">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="form-group">
            <div class="col-xs-6">
                <label class="control-label">Is plan prepared under the instruction of Department of Planning, Lands and Heritage?</label>
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <div class="input-group">
                        @for (option of yesNoOptions; track option; let i = $index) {
                            <label class="nlr-radio">
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error': dolInstructedPlanInput.invalid && dolInstructedPlanInput.dirty}"
                                    [name]="'dolInstructedPlan' + i"
                                    #dolInstructedPlanInput="ngModel"
                                    [id]="'dolInstructedPlan' + i"
                                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                    [value]="option.value"
                                    [(ngModel)]="getCrownStateLand().dolInstructedPlan"
                                    (change)="dolInstructedPlanChanged()"
                                    required
                                    data-test-automation="planning-authority-option-{{option}}" />
                                <span>{{option.displayValue}}</span>
                            </label>
                        }
                    </div>
                }
                @if (getCrownStateLand()?.dolInstructedPlan) {
                    <div>
                        <div class="row">
                            <div class="col-xs-12">
                                <label
                                    class="control-label required-input"
                                    for="dolFileNumber">
                                    Department of Planning, Lands and Heritage file number
                                </label>
                                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                    <div
                                        class="input-group"
                                        [ngClass]="{'has-error': dolFileNumberInput.invalid && dolFileNumberInput.dirty}">
                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="dolFileNumber"
                                            #dolFileNumberInput="ngModel"
                                            id="dolFileNumber"
                                            placeholder="Enter file number"
                                            title="The Department of Planning, Lands and Heritage file number associated with the plan"
                                            maxlength-input-limit="40"
                                            [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                            [(ngModel)]="getCrownStateLand().dolFileNumber"
                                            [required]="getCrownStateLand().dolInstructedPlan"
                                            maxlength="40"
                                            data-test-automation="file-number" />
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="row">
                            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                <div class="col-xs-12">
                                    <label class="control-label">Notice of intention to take?</label>
                                    @for (option of yesNoOptions; track option; let i = $index) {
                                        <label class="nlr-radio">
                                            <input
                                                type="radio"
                                                [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                                [ngClass]="{'has-radio-error': noticeOfIntentionToTakeInput.invalid && noticeOfIntentionToTakeInput.dirty}"
                                                [name]="'noticeOfIntentionToTake'+i"
                                                #noticeOfIntentionToTakeInput="ngModel"
                                                [id]="'noticeOfIntentionToTake'+i"
                                                [value]="option.value"
                                                [(ngModel)]="getCrownStateLand().hasNoticeOfIntentionToTake"
                                                required
                                                data-test-automation="planning-authority-option-{{option}}" />
                                            <span>{{option.displayValue}}</span>
                                        </label>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
            <div class="col-xs-6">
                <label class="control-label">
                    Has advice been sought from Department of Planning, Lands and Heritage on Crown conveyancing matters?
                </label>
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <div class="input-group">
                        @for (option of yesNoOptions; track option; let i = $index) {
                            <label class="nlr-radio">
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':dolAdvisedPlanInput.errors?.required && dolAdvisedPlanInput.dirty}"
                                    #dolAdvisedPlanInput="ngModel"
                                    [name]="'dolAdvisedPlan'+i"
                                    [id]="'dolAdvisedPlan'+i"
                                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                    [value]="option.value"
                                    [(ngModel)]="getCrownStateLand().dolAdvisedPlan"
                                    required
                                    data-test-automation="planning-authority-option-{{option.displayValue}}" />
                                <span>{{option.displayValue}}</span>
                            </label>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidCrownStateLandText}}</span>-->
<!--</div>-->
